/// <amd-module name="Artifacts/FeedSettings/helpers/ViewHelpers" />
import * as Res from "Artifacts/FeedSettings/Resources";
import { FeedPermission, FeedView, FeedVisibility } from "Artifacts/Root/web-apis/contracts/Feed";
import * as StringUtils from "VSS/Core/Util/String";

export function getAccessPermissionsString(
  view: FeedView,
  collectionName: string,
  viewPermissions: FeedPermission[],
): string {
  if (view.visibility === FeedVisibility.AadTenant) {
    return [
      Res.FeedSettings_Views_Grid_Permissions_Private,
      Res.FeedSettings_Views_Grid_Permissions_AadTenant,
    ].join("; ");
  } else if (view.visibility === FeedVisibility.Collection) {
    return [
      Res.FeedSettings_Views_Grid_Permissions_Private,
      StringUtils.format(Res.FeedSettings_Views_Grid_Permissions_Collection, collectionName),
    ].join("; ");
  }

  return [
    Res.FeedSettings_Views_Grid_Permissions_Private,
    ...viewPermissions.map((permission) => permission.displayName),
  ].join("; ");
}
